import { render, staticRenderFns } from "./data32.vue?vue&type=template&id=7444b14a&scoped=true"
import script from "./data32.vue?vue&type=script&lang=js"
export * from "./data32.vue?vue&type=script&lang=js"
import style1 from "./data32.vue?vue&type=style&index=1&id=7444b14a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7444b14a",
  null
  
)

export default component.exports